



















import { computed, defineComponent, ref, onActivated, onDeactivated } from '@vue/composition-api';
import { useStore } from '@/store';
import ComparisonRow from '@/components/Comparison/ComparisonRow.vue';

export default defineComponent({
    name: 'DealerContactsRow',
    components: { ComparisonRow },
    setup () {
        const store = useStore();
        const items = computed(() => store.state.tickedItems);
        const phones = computed(() => store.state.phones);
        const ownerIds = computed(() => store.state.ownerIds);
        const isOpened = computed(() => store.state.isOpened);
        const facebookIds = computed(() => store.state.facebookIds);
        const smsMessages = computed(() => store.state.smsMessages);
        const aux = computed(() => store.state.auxData);
        const phoneButtons = computed(() => store.state.phoneButtons);
        const whatsappHint = computed(() => store.state.whatsappHint);

        const sets = computed(() => items.value.map((id, i) => ({
            vehicleId: id,
            advertLink: aux.value.domain + id,
            callStatId: aux.value.phoneBtnStatId,
            domainName: aux.value.domain,
            googleConversion: aux.value.googleConversion,
            googlePhoneTrack: aux.value.googleTrack,
            messageText: smsMessages.value[i],
            smsStatId: aux.value.smsBtnStatId,
            statUserId: ownerIds.value[i],
            whatsAppStatId: aux.value.whatsappBtnStatId,
            facebookUID: facebookIds.value[i],
            isOpened: isOpened.value[i]
        })));

        const isActivated = ref(true);
        onActivated(() => {
            isActivated.value = true;
        });
        onDeactivated(() => {
            isActivated.value = false;
        });

        return { items, phones, sets, phoneButtons, whatsappHint, isActivated };
    }
});
